<style lang="scss" scoped>
.week {
  label {
    display: inline-block;
    padding: 10px 20px;
    margin: 0 20px;
    cursor: pointer;
    background: #989898;
    border-radius: 5px;
    color: #fff;
  }
  .weekChecked {
    background: #082044;
  }
}
.add-radio {
  padding: 30px 0;
}
.add-plus {
  text-align: center;
  margin: 30px 0;
  i {
    cursor: pointer;
  }
}
.add-limit {
  padding: 20px 0;
}
.add-time {
  padding: 10px 20px;
}
.availableTimes,
.notAvailableTimes {
  padding: 20px 0;
  border-bottom: 1px solid #ccc;
  .time {
    margin-left: 20px;
    margin-bottom: 20px;
    font-size: 16px;
    .delete {
      font-size: 30px;
      margin-left: 40px;
      cursor: pointer;
    }
  }
  .limit {
    padding-top: 20px;
    color: #082044;
    display: flex;
    width: 400px;
    .start,
    .end {
      flex: 1;
      font-size: 36px;
      text-align: center;
      p {
        font-size: 16px;
        color: #333;
      }
    }
    .mid {
      flex: 1;
      width: 100%;
      height: 1px;
      background: #000;
      position: relative;
      top: 25px;
    }
  }
}
</style>
<template>
  <div class="ui-wrap">
    <div class="ui-box box-container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="Available times" name="available">
          <div
            v-for="(item, index) in availableTimes"
            :key="index"
            class="availableTimes"
          >
            <div class="time">
              {{ item.timeIntervalBegin }} ~ {{ item.timeIntervalEnd }}
              <el-popconfirm
                class="popconfirm"
                icon="el-icon-info"
                icon-color="red"
                title="Confirm delete?"
                @confirm="del(index, item.scheduleEntryList.scheduleId, 1)"
              >
                <i slot="reference" class="el-icon-delete delete"></i>
              </el-popconfirm>
            </div>
            <div class="week">
              <label
                v-for="(cell, n) in item.scheduleEntryList.weekDays"
                :key="n"
                :class="{ weekChecked: cell.state }"
                >{{ cell.name }}</label
              >
            </div>
            <div class="limit">
              <div class="start">
                {{ item.scheduleEntryList.timeBegin }}
                <p>Start</p>
              </div>
              <div class="mid"></div>
              <div class="end">
                {{ item.scheduleEntryList.timeEnd }}
                <p>End</p>
              </div>
            </div>
          </div>
          <div class="add-plus">
            <i
              style="font-size: 36px"
              class="el-icon-circle-plus"
              @click="showAdd = true"
            ></i>
          </div>
          <div class="add" v-if="showAdd">
            <div class="add-radio">
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 1 }"
                @click="setTimeType(1)"
                >{{ $t('curriculum.cycle.month') }}</label
              >
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 2 }"
                @click="setTimeType(2)"
                >{{ $t('curriculum.cycle.quarter') }}</label
              >
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 3 }"
                @click="setTimeType(3)"
                >{{ $t('curriculum.cycle.year') }}</label
              >
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 4 }"
                @click="setTimeType(4)"
                >{{ $t('chooseOwnPeriod') }}</label
              >
              <el-date-picker
                value-format="yyyy-MM-dd"
                @change="setTime"
                v-model="addContent.timeRender"
                type="daterange"
                :range-separator="$t('common.till')"
                :start-placeholder="$t('common.startTime')"
                :end-placeholder="$t('common.endTime')"
                style="width: 430px"
              ></el-date-picker>
            </div>
            <!-- {{ addWeek }} -->
            <div class="week">
              <label
                v-for="(cell, n) in addContent.week"
                :key="n"
                @click="addContent.week[n].state = !cell.state"
                :class="{ weekChecked: cell.state }"
                >{{ cell.name }}</label
              >
            </div>
            <div class="add-limit">
              <span style="margin: 0 20px">Start</span>
              <el-time-select
                v-model="addContent.scheduleEntryList.timeBegin"
                class="timepicker"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45',
                }"
                :placeholder="$t('common.startTime')"
              ></el-time-select>
              <span style="margin: 0 20px">End</span>
              <el-time-select
                v-model="addContent.scheduleEntryList.timeEnd"
                class="timepicker"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45',
                  minTime: addContent.scheduleEntryList.timeBegin,
                }"
                :placeholder="$t('common.endTime')"
              ></el-time-select>
            </div>
            <div class="btn">
              <div class="ui-btn" @click="save(1)">{{ $t('common.save') }}</div>
              <div
                style="margin-left: 20px"
                class="ui-btn"
                @click="showAdd = false"
              >
                {{ $t('cancel') }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Non-available times" name="nonAvailable">
          <div
            v-for="(item, index) in nonAvailableTimes"
            :key="index"
            class="notAvailableTimes"
          >
            <div class="time">
              <label>{{ item.scheduleDate }}</label>
              <el-popconfirm
                class="popconfirm"
                icon="el-icon-info"
                icon-color="red"
                title="Confirm delete?"
                @confirm="del(index, item.scheduleId, 2)"
              >
                <i slot="reference" class="el-icon-delete delete"></i>
              </el-popconfirm>
            </div>
            <div class="limit">
              <div class="start">
                {{ item.timeBegin }}
                <p>Start</p>
              </div>
              <div class="mid"></div>
              <div class="end">
                {{ item.timeEnd }}
                <p>End</p>
              </div>
            </div>
          </div>
          <div class="add-plus">
            <i
              style="font-size: 36px"
              class="el-icon-circle-plus"
              @click="showAdd2 = true"
            ></i>
          </div>
          <div class="add" v-if="showAdd2">
            <div class="add-radio">
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 1 }"
                @click="setTimeType(1)"
                >{{ $t('curriculum.cycle.month') }}</label
              >
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 2 }"
                @click="setTimeType(2)"
                >{{ $t('curriculum.cycle.quarter') }}</label
              >
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 3 }"
                @click="setTimeType(3)"
                >{{ $t('curriculum.cycle.year') }}</label
              >
              <label
                class="ui-radio"
                :class="{ checked: addContent.timeIntervalType === 4 }"
                @click="setTimeType(4)"
                >{{ $t('chooseOwnPeriod') }}</label
              >
              <el-date-picker
                value-format="yyyy-MM-dd"
                @change="setTime"
                v-model="addContent.timeRender"
                type="daterange"
                :range-separator="$t('common.till')"
                :start-placeholder="$t('common.startTime')"
                :end-placeholder="$t('common.endTime')"
                style="width: 430px"
              ></el-date-picker>
            </div>
            <div>
              <label class="add-time">{{ $t('common.time') }}</label>
              <el-date-picker
                value-format="yyyy-MM-dd"
                @change="setTime"
                v-model="addContent.scheduleEntryList.scheduleDate"
                type="date"
              ></el-date-picker>
            </div>
            <div class="add-limit">
              <span style="margin: 0 20px">Start</span>
              <el-time-select
                v-model="addContent.scheduleEntryList.timeBegin"
                class="timepicker"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45',
                }"
                :placeholder="$t('common.startTime')"
              ></el-time-select>
              <span style="margin: 0 20px">End</span>
              <el-time-select
                v-model="addContent.scheduleEntryList.timeEnd"
                class="timepicker"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:45',
                  minTime: addContent.scheduleEntryList.timeBegin,
                }"
                :placeholder="$t('common.endTime')"
              ></el-time-select>
            </div>
            <div class="btn">
              <div class="ui-btn" @click="save(2)">{{ $t('common.save') }}</div>
              <div
                style="margin-left: 20px"
                class="ui-btn"
                @click="showAdd1 = false"
              >
                {{ $t('cancel') }}
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
// import uiselect from '@/components/Select.vue'
import {
  getScheduleListByTeacherId,
  scheduleCreate,
  scheduleDel,
  getBaseProfile
} from '@/service/teacherApi.js'
import { changeToSecondd, changeToString } from '@/service/util.js'
import moment from 'moment'
import jstz from 'jstz'
export default {
  // components: { uiselect },
  data() {
    return {
      //
      showAdd: false,
      showAdd2: false,
      activeName: 'available',
      canArr: [],
      addContent: {
        week: [],
        timeIntervalType: 1,
        timeIntervalBegin: '',
        timeIntervalEnd: '',
        timeRender: null,
        scheduleEntryList: {
          timeBegin: '',
          timeEnd: '',
          weekDays: '',
          entryType: 1,
          scheduleDate: '',
        },
      },
      timeZone: "",
      originArr: [],
      availableTimes: [],
      nonAvailableTimes: [],
    }
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    }
  },
  methods: {
    async save(type) {
      let res1=await getBaseProfile({ teacherId: this.user.uid })
      if (res1.data.status === 1) {
        this.timeZone = res1.data.data.timeZone
      }
      console.log(this.timeZone);
      switch (this.addContent.timeIntervalType) {
        case 1:
          // console.log(moment().format('X'));
          this.addContent.timeIntervalBegin = moment(
            moment().startOf('month').format('YYYY-MM-DD')
          ).format('X')
          this.addContent.timeIntervalEnd = moment(
            moment().endOf('month').format('YYYY-MM-DD')
          ).format('X')
          break
        case 2:
          let q = moment().quarter()
          this.addContent.timeIntervalBegin = moment(
            moment(moment().format('YYYY-') + (q * 3 - 2) + '-01').format(
              'YYYY-MM-DD'
            )
          ).format('X')
          this.addContent.timeIntervalEnd = moment(
            moment(moment().format('YYYY-') + q * 3 + '-01')
              .endOf('month')
              .format('YYYY-MM-DD')
          ).format('X')
          break
        case 3:
          this.addContent.timeIntervalBegin = moment(moment()
            .startOf('year')
            .format('YYYY-MM-DD')).format('X')
          this.addContent.timeIntervalEnd = moment(moment()
            .endOf('year')
            .format('YYYY-MM-DD')).format('X')
          break
        case 4:
      }
      const param = {
        timeIntervalType: this.addContent.timeIntervalType,
        timeIntervalBegin: this.addContent.timeIntervalBegin,
        timeIntervalEnd: this.addContent.timeIntervalEnd,
        scheduleId: '',
        scheduleEntryList: JSON.stringify([
          {
            scheduleDate: this.addContent.scheduleEntryList.scheduleDate
              ? moment(this.addContent.scheduleEntryList.scheduleDate).format(
                'X'
              )
              : '',
            scheduleEntryType: type,
            timeBegin: !!this.addContent.scheduleEntryList.timeBegin
              ? changeToSecondd(this.addContent.scheduleEntryList.timeBegin)
              : '',
            timeEnd: !!this.addContent.scheduleEntryList.timeEnd
              ? changeToSecondd(this.addContent.scheduleEntryList.timeEnd)
              : '',
            weekDays: this.addContent.week
              .map((item, index) => (item.state ? index + 1 : ''))
              .filter((i) => i !== '')
              .join(','),
          },
        ]),
        timeZone: this.timeZone,
      }
      let res = await scheduleCreate(param)
      if (res.data.status === 1) {
        this.$message({
          message: this.$t('common.saveSuccess'),
          type: 'success',
        })
        this.$nextTick(() => {
          this.getScheduleListByTeacherId()
        })
      }
    },
    setTime(val) {
      if (this.addContent.timeIntervalType === 4 && !!val) {
        this.addContent.timeIntervalBegin = moment(val[0]).format('X')
        this.addContent.timeIntervalEnd = moment(val[1]).format('X')
      } else {
        this.addContent.timeRender = null
      }
    },
    setTimeType(n) {
      this.addContent.timeIntervalType = n
      this.addContent.timeRender = null
    },
    async del(index, scheduleId, type) {
      let res = await scheduleDel({
        scheduleId,
      })
      if (res.data.status === 1) {
        this.$message({
          message: this.$t('common.delSuccess'),
          type: 'success',
        })
        if (type === 1) {
          this.availableTimes.splice(index, 1)
        } else {
          this.nonAvailableTimes.splice(index, 1)
        }
      }
    },
    setAll(obj) { },
    async getScheduleListByTeacherId() {
      Object.assign(this.$data, this.$options.data())
      let timeBegin = moment(
        moment().startOf('month').format('YYYY-MM-DD')
      ).format('X')
      let timeEnd = moment(moment().endOf('month').format('YYYY-MM-DD')).format(
        'X'
      )
      let res = await getScheduleListByTeacherId({
        teacherId: this.user.uid,
        timeIntervalBegin: timeBegin,
        timeIntervalEnd: timeEnd,
        targetTimeZone: jstz.determine().name(),
      })
      if (res.data.status === 1) {
        this.canArr = [
          { name: this.$t('weeks.mon'), state: false },
          { name: this.$t('weeks.tues'), state: false },
          { name: this.$t('weeks.wed'), state: false },
          { name: this.$t('weeks.thur'), state: false },
          { name: this.$t('weeks.fri'), state: false },
          { name: this.$t('weeks.sat'), state: false },
          { name: this.$t('weeks.sun'), state: false },
        ]
        this.addContent.week = this.canArr
        if (res.data.data.length) {
          // console.log(res.data.data);
          this.originArr = res.data.data
          this.originArr.forEach((item) => {
            const availableTimes = []
            item.entries.forEach((val) => {
              if (val.scheduleEntryType === 1) {
                val.timeBegin = !!val.timeBegin
                  ? changeToString(val.timeBegin)
                  : ''
                val.timeEnd = !!val.timeEnd ? changeToString(val.timeEnd) : ''
                const weekDays = []
                val.weekDays = !!val.weekDays
                  ? this.canArr.map((item, index) => ({
                    name: item.name,
                    state:
                      val.weekDays.indexOf(index + 1) >= 0 ? true : false,
                  }))
                  : this.canArr

                this.availableTimes.push({
                  timeZone: item.timeZone,
                  scheduleEntryType: item.scheduleEntryType,
                  timeIntervalBegin: moment(
                    item.timeIntervalBegin * 1000
                  ).format('DD/MM/YYYY'),
                  timeIntervalEnd: moment(item.timeIntervalEnd * 1000).format(
                    'DD/MM/YYYY'
                  ),
                  scheduleEntryList: val,
                })
              } else if (val.scheduleEntryType === 2) {
                val.timeBegin = !!val.timeBegin
                  ? changeToString(val.timeBegin)
                  : ''
                val.scheduleDate = !!val.scheduleDate
                  ? moment(val.scheduleDate * 1000).format('DD/MM/YYYY')
                  : ''
                val.timeEnd = !!val.timeEnd ? changeToString(val.timeEnd) : ''
                this.nonAvailableTimes.push(val)
              }
            })
          })
        }
      }
    },
    handleClick(tab, event) {
      // console.log(this.$data);
      // console.log(this.$options);
      // Object.assign(this.$data, this.$options.data());
    },
    goback() {
      window.history.go(-1)
    },
  },
  async mounted() {
    // this.getSchedule()
    await this.getScheduleListByTeacherId()
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
}
</script>
<style lang="scss">
.box-container {
  padding: 20px;
}
</style>